import { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Balance from "./components/Balance";
import Form from "./components/Form";
import Layout from "./components/Layout";
import AllTransaction from "./components/Transactions/AllTransaction";
import Transactions from "./components/Transactions/Transactions";

function App() {
    const [triggerEdit, setTriggerEdit] = useState(false);
  return (
    <BrowserRouter>
      <Layout>
        <Balance />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Form setTriggerEdit={setTriggerEdit}/>
                <Transactions triggerEdit={triggerEdit} setTriggerEdit={setTriggerEdit}/>
              </>
            }
          />
          <Route path="/all_transactions" element={<AllTransaction triggerEdit={triggerEdit} setTriggerEdit={setTriggerEdit}/>} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;

